import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import Aboutus from './Js_files/Aboutus.jsx';
import Register from './Js_files/Registration.jsx';
import Login from './Js_files/Login.jsx';
import Full_ContactUs from './Js_files/Full_contact.jsx';
import File1 from './Js_files/file1.jsx';
import Blog from './Js_files/blog.jsx';
import File3 from './Js_files/file3.jsx';
import File4 from './Js_files/file4.jsx';
import File5 from './Js_files/file5.jsx';
import File6 from './Js_files/file6.jsx';
import Full_career from './Js_files/Full_career.jsx';
import Full_internship from './Js_files/Full_internship.jsx';
import Full_blog from './Js_files/Full_blog.jsx';
import File2 from './Js_files/file2.jsx';
import File7 from './Js_files/file7.jsx';
import Mechanical from './Js_files/mech.jsx';
import Full_Homepage from './Js_files/Full_Homepage.jsx';
import Civil from './Js_files/civil.jsx';
import Ece from './Js_files/ece.jsx';
import Electronics from './Js_files/electronics.jsx';
import ComputerScience from './Js_files/computer.jsx';
import ArtsMultimedia from './Js_files/arts_multi.jsx';
import ExpertTips from './Js_files/Expert_tips.jsx';
import PlacementNews from './Js_files/Placement.jsx';
import GalleryShowcase from './Js_files/Full_gallery.jsx';
import Mou from './Js_files/Mou.jsx';
import Certification from './Js_files/Certification.jsx';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Full_Homepage />} />
          <Route path="/about" element={<Aboutus />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/contact" element={<Full_ContactUs />} />
          <Route path="/blog1" element={<File1 />} />
          <Route path="/blog" element={<Full_blog/>} />
          <Route path="/blog2" element={<File2/>} />
          <Route path="/blog3" element={<File3 />} />
          <Route path="/blog4" element={<File4 />} />
          <Route path="/blog5" element={<File5 />} />
          <Route path="/blog6" element={<File6 />} />
          <Route path="/career" element={<Full_career />} />
          {/* <Route path="/internshipc1" element={<Internship_c1/>} /> */}
          <Route path="/internship" element={<Full_internship />} />
          {/* <Route path="/blogc1" element={<BlogPage_c1/>} /> */}
          <Route path="/fullblog" element={<Full_blog />} />
          {/* <Route path="/blogc2" element={<Blog_c2/>} /> */}
          <Route path="/blog7" element={<File7/>} />
          <Route path="/mech" element={<Mechanical/>} />
          <Route path="/civil"  element={<Civil/>}/>
          <Route path="/ece"  element={<Ece/>}/>
          <Route path="/electronics"  element={<Electronics/>}/>
          <Route path="/computerscience"  element={<ComputerScience/>}/>
          <Route path="/ArtsMultimedia" element={<ArtsMultimedia/>} />
          <Route path="/expert" element={<ExpertTips/>}/>
          <Route path="/placement" element={<PlacementNews/>}/>
          <Route path="/gallery" element={<GalleryShowcase/>}/>
          <Route path="/mou" element={<Mou/>}/>
          <Route path="/certification" element={<Certification/>}/> 
        </Routes>
      </div>
    </Router>
  );
}

export default App;
